import axiosInstance from '../../../utils/apiConfig';

const partnerUsersApi = {
  // Get all partner users (admin view)
  getAll: (params) =>
    axiosInstance
      .get('/b2b/users', { params })
      .then((res) => res.data),

  // Get users by partner
  getByPartner: (partnerId, params) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/users`, { params })
      .then((res) => res.data),

  // Get single user
  getById: (partnerId, userId) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/users/${userId}`)
      .then((res) => res.data),

  // Create new partner user
  create: (partnerId, data) =>
    axiosInstance
      .post(`/b2b/partners/${partnerId}/users`, data)
      .then((res) => res.data),

  // Update partner user
  update: (partnerId, userId, data) =>
    axiosInstance
      .put(`/b2b/partners/${partnerId}/users/${userId}`, data)
      .then((res) => res.data),

  // Delete partner user
  delete: (partnerId, userId) =>
    axiosInstance
      .delete(`/b2b/partners/${partnerId}/users/${userId}`)
      .then((res) => res.data),

  // Reset user password
  resetPassword: (partnerId, userId, password) =>
    axiosInstance
      .post(`/b2b/partners/${partnerId}/users/${userId}/reset-password`, { password })
      .then((res) => res.data),

  // Toggle user active status
  toggleActive: (partnerId, userId) =>
    axiosInstance
      .patch(`/b2b/partners/${partnerId}/users/${userId}/toggle-active`)
      .then((res) => res.data),
};

export default partnerUsersApi;
